<template>
  <div v-loading="loading">
    <div class="header">
      <div></div>
      <el-button type="primary" @click="$router.push({ name: 'FinancialStatisticMetadataAdd' })">
        Qo'shish
      </el-button>
    </div>

    <el-table class="table-body" :data="tableData" border height="calc(100vh - 250px)">
      <el-table-column type="index" label="T/r" width="60" />
      <el-table-column prop="title" label="Sarlavha" min-width="300" />
      <el-table-column label="Fayl nomi" min-width="200">
        <template #default="scope">
          {{ scope.row.file_name || '—' }}
        </template>
      </el-table-column>
      <el-table-column label="Format" width="90" align="center">
        <template #default="scope">
          {{ scope.row.file_extension ? `.${scope.row.file_extension}` : '—' }}
        </template>
      </el-table-column>
      <el-table-column label="Sana" width="130" align="center">
        <template #default="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="Amallar" width="175" align="center">
        <template #default="scope">
          <el-button
            size="small"
            type="primary"
            @click="$router.push({ name: 'FinancialStatisticMetadataEdit', params: { id: scope.row.id } })"
          >
            Tahrirlash
          </el-button>
          <el-button size="small" type="danger" @click="deleteItem(scope.row.id)">
            O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import http from "@/http";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const loading = ref(false);
const tableData = ref([]);
const totalCount = ref(0);
const limit = ref(20);
const currentPage = ref(1);

const formatDate = (val) =>
  val ? new Date(val).toLocaleDateString("uz-UZ") : "—";

const fetchList = () => {
  loading.value = true;
  http
    .get("api/v1/financial-statistic-metadata", {
      params: {
        lang: "uz_lat",
        limit: limit.value,
        offset: limit.value * (currentPage.value - 1),
      },
    })
    .then(({ data }) => {
      tableData.value = data.result;
      totalCount.value = data.count;
    })
    .catch(({ response }) => {
      ElNotification.error({
        message: response?.data?.message || "Ma'lumot yuklashda xatolik sodir bo'ldi!",
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

const deleteItem = (id) => {
  ElMessageBox.confirm("Metadatani o'chirasizmi?", "Diqqat!", {
    confirmButtonText: "Ha",
    cancelButtonText: "Bekor qilish",
    type: "warning",
  })
    .then(() => {
      loading.value = true;
      http
        .delete(`api/v1/financial-statistic-metadata/${id}`)
        .then(() => {
          ElMessage({ type: "success", message: "Muvaffaqqiyatli o'chirildi" });
          fetchList();
        })
        .catch(() => {
          ElNotification({ type: "error", title: "Xatolik", message: "Iltimos, qayta urinib ko'ring" });
        })
        .finally(() => {
          loading.value = false;
        });
    })
    .catch(() => {
      ElMessage({ type: "info", message: "O'chirish bekor qilindi" });
    });
};

const handleCurrentChange = () => {
  router.replace({ query: { ...route.query, page: currentPage.value } });
  fetchList();
};

const handleSizeChange = () => {
  currentPage.value = 1;
  router.replace({ query: { ...route.query, size: limit.value, page: 1 } });
  fetchList();
};

onMounted(() => {
  if (route.query.size) limit.value = parseInt(route.query.size);
  if (route.query.page) currentPage.value = parseInt(route.query.page);
  fetchList();
});
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
